import React from 'react'
import { Modal } from 'react-bootstrap';

const GenericAddressListComponent = ({
    show,
    setShow,
    allAddress,
    onEditHandler,
    onDeleteHandler,
    onAddAddressHandler,
    values,
    setValues,

}) => {
    return (
        <div>
            <Modal
                show={show}
                onHide={() => { setShow(false); }}
                showClose={true}
                centered
            >
                <div className="allAddressModal m-0 p-0">
                    <div className="title">All Address</div>
                    <div className="straightLine"></div>
                    <div className="selectAddress">Select Address</div>
                    <div className="addressContainer">
                        <div className="addressDiv">
                            {
                                allAddress.map((el, id) => {
                                    return (
                                        <div className="container" key={id}>
                                            <div className="addressDiv">
                                                <input
                                                    className="btn-radio"
                                                    type="radio"
                                                    name="rd1"
                                                    checked={values?.billingAddress == el._id}
                                                    value={el._id}
                                                    style={{ marginRight: "5px" }}
                                                    onClick={() => {
                                                        setError({
                                                            ...error,
                                                            billingAddress: "",
                                                        })
                                                        setValues({ ...values, billingAddress: el._id })
                                                    }}
                                                />
                                                <div className="address">
                                                    <div className="name">{el?.firstName}{" "}{el?.lastName}</div>
                                                    <div className="add">{el?.addressLineOne}{" "}{el?.addressLineTwo}{" "}{el?.city}{" "}{el?.state}{" "}{el.postalCode}{" "}{el.country}</div>
                                                </div>
                                            </div>
                                            <div className="buttons">
                                                <div className="edit" onClick={() => onEditHandler(el._id)}>Edit</div>|
                                                <div className="delete" onClick={() => onDeleteHandler(el._id)}>Delete</div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="straightLine"></div>
                    <div className="bottomLinks">
                        <div className="addNew" onClick={onAddAddressHandler}>
                            + Add New Address
                        </div>
                        <div className="buttons">
                            {/* <div className="back"}>
                      Back
                    </div> */}
                            <div className="done" onClick={() => {
                                setShow(false);
                            }
                            }>
                                Done
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default GenericAddressListComponent